import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let LocalTopTips = class LocalTopTips extends Vue {
    constructor() {
        super(...arguments);
        this.tipsShow = true;
    }
    get hasShowTips() {
        return !localStorage.hasOwnProperty(`top-tips-${this.callName}-${this.examId}`);
    }
    mounted() {
        console.log("showCloseIcon", this.showCloseIcon);
    }
    closeTips() {
        this.tipsShow = false;
        localStorage.setItem(`top-tips-${this.callName}-${this.examId}`, 'false');
    }
};
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], LocalTopTips.prototype, "callName", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: true })
], LocalTopTips.prototype, "showCloseIcon", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], LocalTopTips.prototype, "examId", void 0);
LocalTopTips = tslib_1.__decorate([
    Component({
        name: 'LocalTopTips',
    })
], LocalTopTips);
export default LocalTopTips;
